//import stlFileMapping from './stlFile'
//import parseSTLByLumiaLase from './lumialase'


const shapeProfileMapping = async (data, state) => {
	//sections, stlPoints, filesUrl
	return {
		name: data?.shape_profile_name,
		logo_parameters: {
			camera_job_id: data?.logo_parameters_camera_job_id,
			size: {
				width: Number(data?.logo_parameters_size_width),
				height: Number(data?.logo_parameters_size_height),
			},
			offset_y: Number(data?.logo_parameters_offset_y),
			offset_angle: Number(data?.logo_parameters_offset_angle),
			led_brightness: {
				red: 0,
				green: 0,
				blue: 0,
				white: data?.logo_parameters_led_brightness// === 'bright' ? 255 : 0,
			},
		},
		gripper_plane: {
			position: {
				x: Number(data?.gripper_plane_x),
				y: Number(data?.gripper_plane_y),
				z: Number(data?.gripper_plane_z),
			},
			angle: {
				x: Number(data?.gripper_plane_x_angle),
				y: Number(data?.gripper_plane_y_angle),
				z: Number(data?.gripper_plane_z_angle),
			},
		},
		center_of_gravity: {
			x: Number(data?.center_of_gravity_x) / 1000,
			y: Number(data?.center_of_gravity_y) / 1000,
			z: Number(data?.center_of_gravity_z) / 1000,
		},
		mass: Number(data?.mass),
		mass_unit_name: data?.mass_unit_name,
		distance_unit_name: data?.distance_unit_name,
		angle_unit_name: data?.angle_unit_name,
		revolve_vector: {
			x: 0,
			y: 1,
			z: 0,
		},
		center: {
			x: 0,
			y: 0,
			z: 0,
		},
		//"profile_points": stlFileMapping(stlFile),
		profile_points: state?.loadSTL,
		height: Number(data?.height),
		base_point: {
			x: Number(data?.base_point_x),
			y: Number(data?.base_point_y),
			z: Number(data?.base_point_z),
		},
		base_radius: 5.0, //not needed in UI
		top_radius: 3.5, //not needed in UI
		z_offset: 2.0, //not needed in UI
		surface_marking_method: data?.surface_marking_method,
		shape: data?.shape,
		sections: state.createSections,
		tool_id: data?.tool_id,
		'3d_model_url': state?.uploadGlb,
		stl_url: state?.uploadSTL,
		id: state.product.shapeId,
	}
}
export default shapeProfileMapping
